<template>
  <div class="financeChain">
    <div class="one1">
      <img src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/home_back19.jpg" alt="">
      <div class="one1_content finace_content">
        <div class="title_name title_name_one">代赎货</div>
        <div class="title_name title_name_two">全流程线上操作、融资便利、赎货简单、灵活方便、服务更好</div>
      </div>
    </div>
    <div class="one2">
      <div class="one2_content finace_content">
        <div class="left">
          <div class="title">什么是代赎货？</div>
          <div class="explain">德木云ERP系统用户通过申请在途金融资质，获得金融公司&银行在线代赎货金融服务。</div>
          <div class="keyword">全流程在线操作、融资便利、赎货简单、灵活方便、服务更好</div>
          <div class="operat">
            <div class="bottom">我要融</div>
            <i class="icon iconfont iconzu1568"></i>
            <div class="phone">咨询热线：13636535807</div>
          </div>
        </div>
        <div class="right wow animate__animated animate__bounceInRight" data-wow-delay ="0.2s">
          <img src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/home_back20.jpg" alt="">
        </div>
      </div>
    </div>
    <div class="one3">
      <div class="homeTitle">
        <div class="name">业务流程</div>
      </div>
      <div class="explain">OPERATION FLOW</div>
      <div class="one3_content finace_content">
        <div class="contentList">
          <div class="left">融资流程</div>
          <div class="right">
            <div class="item animate__animated animate__bounceInRight" data-wow-delay ="0.2s" v-for="(item,index) in rz_list" :key="index">
              <hpBottom :number="item.number" :tetx="item.name" :img="item.icon" />
            </div>
          </div>
        </div> 
        <div class="contentList">
          <div class="left">赎货流程</div>
          <div class="right">
            <div class="item">方式一：装车赎货</div>
            <div class="item animate__animated animate__bounceInRight" data-wow-delay ="0.4s" v-for="(item,index) in sh_listone" :key="index">
              <kpBottom :number="item.number" :tetx="item.name" />
            </div>
          </div>
        </div>
        <div class="contentList">
          <div class="left"></div>
          <div class="right">
            <div class="item">方式二：提前赎货</div>
            <div class="item animate__animated animate__bounceInRight" data-wow-delay ="0.6s" v-for="(item,index) in sh_listtwo" :key="index">
              <kpBottom :number="item.number" :tetx="item.name" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="one4">
      <div class="homeTitle" style="border:0">
        <div class="icon_back">
          <div class="title_content">
            <div class="title"><i class="icon el-icon-picture"></i><span class="name">德木小课堂</span></div>
            <div class="explain">DEMU PRIMARY SCHOOL</div>
          </div>
        </div>
      </div>
      <div class="one4_content finace_content">
        <img class="icon_back" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/board_back.png" alt="">
        <div class="classroomList">
          <div class="item wow animate__animated animate__bounceInUp" data-wow-delay ="0.2s" v-for="(item,index) in classroomList" :key="index">
            <div class="title">{{item.name}}</div>
            <div class="itemList">
              <div class="left">
                <div class="item" v-for="(em,inde) in item.list" :key="index+'_'+inde">
                  <div class="name">{{em.name}}</div>
                </div>
              </div>
              <div class="right">
                <div class="icon iconfont" :class="item.icon"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="one5">
      <div class="homeTitle">
        <div class="name">合作企业</div>
      </div>
      <div class="explain">COOPERATIVE ENTERPRISE</div>
      <div class="one5_content finace_content">
        <cooperation />
      </div>
    </div>
  </div>
</template>

<script>
import cooperation from '../../home/components/cooperation'
import {WOW} from 'wowjs'
export default {
    name: '',
    components:{
      cooperation
    },
    props: {
      
    },
    data(){
      return{
        rz_list:[
          {number:'01',name:'申请融资',icon:'iconzaixianrongzi'},
          {number:'02',name:'核实审核',icon:'iconshenhe'},
          {number:'03',name:'支付保证金',icon:'iconbaozhengjin'},
          {number:'04',name:'支付贷款代赎完成',icon:'iconwancheng'},
        ],
        sh_listone:[
          {number:'01',name:'装车赎货'},
          {number:'02',name:'按装车付款'},
          {number:'03',name:'完成赎回'},
        ],
        sh_listtwo:[
          {number:'01',name:'向金融公司还清融资款'},
          {number:'02',name:'监管变更'},
          {number:'03',name:'完成赎回'},
        ],
        classroomList:[
          {
            name:'Q1:代赎货需要什么资质？',
            icon:'iconerpkehu',
            list:[
              {name:'凡是德木ERP系统用户，在线融资申请通过后都可以使用。'}
            ],
          },
          {
            name:'Q2:那些货物可以做代赎货？',
            icon:'icondaishuhuofuwu',
            list:[
              {name:'合同提单入库后，可在线提交申请代赎货服务，但仅限线上库的库存。'}
            ],
          },
          {
            name:'Q3代赎货赎回时怎么操作？',
            icon:'icondaishuhuocaozuo1',
            list:[
              {name:'1.装车赎货：系统自动生成装车赎货单，付款后自动货权放行。'},
              {name:'2.提前赎货：一次性付清全部融资款，系统自动监管变更到用户名下'}
            ],
          },
          {
            name:'Q4:代赎货服务周期为多久？',
            icon:'iconfuwuzhouqi',
            list:[
              {name:'正常情况以最大时间90天。'},
            ],
          },
        ],
      }
    },
    mounted(){
      this.$nextTick(() => {
        let wow = new WOW({
          boxClass: "wow",    //需要执行动画的元素的 class
          animateClass: "animated", // animation.css 动画的 class
          offset: 0, // 距离可视区域多少开始执行动画
          mobile: false, // 是否在移动设备上执行动画
          live: false // 异步加载的内容是否有效
        })
        wow.init()
      })
    },
    methods:{

    }
}
</script>

<style scoped  lang="scss">
  .financeChain{overflow: hidden;height: 100%;width: 100%;}
  .homeTitle{border-bottom: 1px solid #E5E6EB;text-align: center;margin-top: 3rem;}
  .homeTitle .name{margin: 0 auto;margin-bottom:3px;line-height: 4.5rem;letter-spacing:0.1rem; font-size: 2.3rem;font-weight: 600;color: #333333;position: relative;margin-left: 0.6rem;}
  .homeTitle .name:after{content: '';width: 10rem;height: 2.7rem;background: #CEDCFF;display: block;border-radius: 0.5rem;transform: translateX(-50%);position: absolute;bottom: 0;left: 51.5%;z-index: -1;}
  .explain{text-align: center;color: #999999;}

  .title_content{width: 26.6rem;height: 8.7rem;margin: 0 auto;background-size: 100% 100%; background: url(https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/board_title.png) no-repeat center center;
    display: flex;align-items: center;justify-content: center;flex-direction: column;
    .title{display: flex;align-items: center;
      .name{line-height: initial;}
    }
    .icon{font-size: 3rem;}
    .explain{color: #333;font-size: 1.4rem;}
  }

  .finace_content{width: 120rem;margin: 0 auto;}
  .one1{
    width: 100%;height: 50rem;
    position: relative;
    .icon{
      height: 100%;width: 100%;
    }
    .one1_content{
      width: 56rem;
      position: absolute;left: 50%;top: 50%;transform: translateX(-50%) translateY(-50%); z-index: 2;
      border-radius: 0.6rem;
      padding: 3rem 5rem;
      color: #fff;
      background: rgba(0, 0, 0, 0.4);
      .title_name{
        font-size: 4rem;
        text-align: center;
      }
      .title_name_one{font-weight: 500;}
      .title_name_two{font-size: 2rem;margin-top: 3rem;text-align: center;}
    }
  }

  .one2{
    width: 100%;
    .one2_content{
      margin-top: 3rem;
      display: flex;
      .left{
        flex: 1;
        padding: 0 2rem;
        font-size: 1.4rem;
        .title{font-size: 2.8rem;}
        .explain{margin: 3rem 0 2rem 0;text-align: left;color: #333;text-indent: 2.8rem;}
        .keyword{font-weight: 600;}
        .operat{
          display: flex;align-items: center;margin-top: 3rem;
          .bottom{padding: 0.6rem 2.2rem;background: #2E6AFB;color: #fff;border-radius: 0.4rem;}
          .bottom:hover{background: #537EF0;cursor: pointer;}
          .icon{font-size: 2rem;margin: 0 1rem 0 2rem;}
        }
      }
      .right{flex: 1;}
    }
  }
  .one3{
    width: 100%;
    .one3_content{
      margin-top: 3rem;
      margin-bottom: 3rem;
      height: 35rem;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      background: #ECEFF7;
      overflow: hidden;
      .contentList{
        width: 100%;
        display: flex;align-items: center;
        .left{flex-basis: 20rem;padding: 0 2rem;font-size: 1.6rem;font-weight: 600;text-align: center;}
        .right{flex: 1;display: flex;align-items: center;justify-content: space-between;
          padding: 0 2rem;
          .item{
            margin-left: 4rem;
            width: 100%;
            font-size: 1.4rem;
          }
        }
      }
    }
  }
  .one4{
    .one4_content{
      margin-top: 2rem;
      border: 0.1rem solid #ddd;
      border-radius: 0.8rem;
      box-shadow: 0 0.2rem 0.4rem rgba(0, 0, 0, 0.2);
      height: 38rem;
      overflow: hidden;
      position: relative;
      .icon_back{width: 100%;height: 100%;}
      .classroomList{
        position: absolute;left: 0;top: 0;height: 100%;
        display: flex;
        flex-wrap: wrap;
        padding: 2rem 2rem 0 0;
        >.item{width: 57rem;padding:0 0 2rem 2rem;
          .title{font-size: 1.8rem;font-weight: 600;margin-bottom: 1.5rem;}
          .itemList{display: flex;background: #fff;width: 100%;height: 8rem;
            box-shadow: 0 0.2rem 0.4rem rgba(0, 0, 0, 0.3);
            border-radius: 0.4rem;
            padding: 1rem 0;
            .left{flex: 1;font-size: 1.4rem;padding: 0 1rem;}
            .right{flex-basis: 6rem;display: flex;justify-content: center;align-items: center;color: #2E6AFB;
              .icon{font-size: 4rem;}
            }
          }
        }
      }
    }
  }
  .one5{
    .one5_content{
      margin-top: 2rem;
      margin-bottom: 2rem;
    }
  }
</style>
